import { Star, ExternalLink } from "lucide-react";
import { useLiveReviews } from "../hooks/useLiveReviews";
import { useT } from "../i18n/LanguageContext";
import Reveal from "./Reveal";

export default function GuideReviews() {
  const tr = useT();
  const { items, rating, placeUrl } = useLiveReviews();

  const three = items.slice(0, 3);
  if (!three.length) return null;

  return (
    <section className="px-6 md:px-12 max-w-[1400px] mx-auto mt-28" data-testid="guide-reviews">
      <Reveal>
        <p className="overline mb-4">{tr("reviews.overline")} · {rating}</p>
        <h2 className="font-serif text-3xl md:text-4xl font-light mb-12 max-w-2xl">{tr("guides.reviewsTitle")}</h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {three.map((r, k) => (
          <Reveal key={`${r.name}-${k}`} delay={k * 0.08}>
            <div className="border border-white/10 p-7 h-full flex flex-col">
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-[#C5A059] text-[#C5A059]" />
                ))}
              </div>
              <p className="text-white/70 text-sm leading-relaxed flex-1">
                “{r.text && r.text.length > 240 ? r.text.slice(0, 240).trim() + "…" : r.text}”
              </p>
              <div className="mt-6">
                <p className="text-[#C5A059] text-sm tracking-wide">{r.name}</p>
                {r.sub && <p className="text-white/40 text-xs mt-1">{r.sub}</p>}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      {placeUrl && (
        <Reveal>
          <a
            href={placeUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="guide-reviews-google"
            className="inline-flex items-center gap-1.5 mt-8 text-white/40 hover:text-[#C5A059] text-xs tracking-wide transition-colors"
          >
            {tr("reviews.viewOnGoogle")} <ExternalLink size={12} />
          </a>
        </Reveal>
      )}
    </section>
  );
}
